export const getMatchingKeys = (
  obj: Record<string, any>,
  regex: RegExp
): string[] => {
  return Object.keys(obj).filter((key) => regex.test(key));
};

export const isEmptyObject = (obj: Record<string, any>): boolean => {
  return Object.values(obj).every((value) => !value);
};

type FieldTransform<T> = {
  [K in keyof T]?: (value: T[K]) => any;
};

export const transformObjectFields = <T extends object>(
  response: T,
  fieldsToParse: FieldTransform<T>
): T => {
  const transformedResponse = { ...response };

  (Object.keys(fieldsToParse) as Array<keyof T>).forEach((field) => {
    if (field in response) {
      transformedResponse[field] = fieldsToParse[field]!(response[field]);
    }
  });

  return transformedResponse;
};
